import React, { useState } from 'react';
import { LayoutDependentTabView } from '../../../../v2BaseComponents/TabView';
import { getIntl } from '../../../../../utils/intl';
import { SideDrawerContainer } from '../../../../v2BaseComponents/SideDrawer';
import NotesTab from './NotesTab';
import CareTeamMembersTab from './CareTeamMembersTab';

const intl = getIntl('resources-root-screen', {
    notes: 'Notes',
    careTeam: 'Care Team',
});

export type ResourcesRootScreenOwnProps = {};

export type ResourcesRootScreenProps = ResourcesRootScreenOwnProps;

type Tab = 'notes' | 'care-team';

const ResourcesRootScreen: React.FC<ResourcesRootScreenProps> = () => {
    const [selectedTab, setSelectedTab] = useState<Tab>('notes');

    return (
        <SideDrawerContainer>
            <LayoutDependentTabView
                selectedTab={selectedTab}
                onChange={setSelectedTab as any}
                restrictedWidthVariant="lg"
                tabs={[
                    {
                        title: intl('notes'),
                        renderTabContent: () => <NotesTab />,
                        value: 'notes',
                    },
                    {
                        title: intl('careTeam'),
                        renderTabContent: () => <CareTeamMembersTab />,
                        value: 'care-team',
                    },
                ]}
            />
        </SideDrawerContainer>
    );
};

export default React.memo(ResourcesRootScreen);
